

export default function() {
    return {
    
        "en": {
            
            "bundles.listings.title": "Listings",
            
            "bundles.dates": "Dates",
            
            "bundles.available": "Available",
            
            "bundles.not_available": "Not available",
            
            "bundles.dates_not_available": "These dates are not available.",
            
            "bundles.listings.availability": "%{count} of %{total} listings available",
            
            "timeline.editor_placeholder": "Enter your message...",
            
            "listings.listings_title": "Spaces",
            
            "invoice.title": "Invoice",
            
            "scheduler.month": "Month",
            
            "scheduler.quarter": "Quarter",
            
            "scheduler.today": "Today",
            
            "scheduler.weeks": "Weeks",
            
            "scheduler.clear": "Clear",
            
            "stripe.persons.invalid_ssn_last_4": "Invalid format",
            
            "campaigns.details.tenant_selected": "Tenant selected",
            
            "campaigns.details.tenants_selected": "Tenants selected",
            
            "campaigns.details.sections.content.enter_message": "Enter your message",
            
            "date.formats.moment": "MM/DD/YYYY",
            
            "offers.controls.booking": "Create a booking",
            
            "offers.controls.offer": "Send offer",
            
            "offers.descriptions.booking": "Create a booking for walk-ins. Fill in the details and the total will be calculated. The payment between the landlord and tenant must be handled in person, either by cash or card. ",
            
            "offers.descriptions.offer": "Send an offer directly to your tenant. Fill in the details and the price will be calculated automatically. The tenant will receive the offer with a link to review, accept and pay it online.",
            
            "offers.title.booking": "Create a booking",
            
            "offers.title.offer": "Send an offer",
            
            "parsley.default_message": "This value seems to be invalid.",
            
            "parsley.type.email": "This value should be a valid email.",
            
            "parsley.type.url": "This value should be a valid url.",
            
            "parsley.type.number": "This value should be a valid number.",
            
            "parsley.type.integer": "This value should be a valid integer.",
            
            "parsley.type.digits": "This value should be digits.",
            
            "parsley.type.alphanum": "This value should be alphanumeric.",
            
            "parsley.notblank": "This value should not be blank.",
            
            "parsley.required": "This value is required.",
            
            "parsley.pattern": "This value seems to be invalid.",
            
            "parsley.min": "This value should be greater than or equal to %s.",
            
            "parsley.max": "This value should be lower than or equal to %s.",
            
            "parsley.range": "This value should be between %s and %s.",
            
            "parsley.minlength": "This value is too short. It should have %s characters or more.",
            
            "parsley.maxlength": "This value is too long. It should have %s characters or less.",
            
            "parsley.length": "This value length is invalid. It should be between %s and %s characters long.",
            
            "parsley.mincheck": "You must select at least %s choices.",
            
            "parsley.maxcheck": "You must select %s choices or less.",
            
            "parsley.check": "You must select between %s and %s choices.",
            
            "parsley.equalto": "This value should be the same.",
            
            "parsley.force_place_select": "Please select a place from the dropdown.",
            
        },
    
        "de": {
            
            "bundles.listings.title": "Inserate",
            
            "bundles.dates": "Termine",
            
            "bundles.available": "Verfügbar",
            
            "bundles.not_available": "Nicht verfügbar",
            
            "bundles.dates_not_available": "Diese Termine sind nicht verfügbar.",
            
            "bundles.listings.availability": "%{count} von %{total} Einträgen verfügbar",
            
            "timeline.editor_placeholder": "Gib eine Nachricht ein...",
            
            "listings.listings_title": "Flächen",
            
            "invoice.title": "Rechnung",
            
            "scheduler.month": "Monat",
            
            "scheduler.quarter": "Quartal",
            
            "scheduler.today": "Heute",
            
            "scheduler.weeks": "Wochen",
            
            "scheduler.clear": "löschen",
            
            "stripe.persons.invalid_ssn_last_4": "Ungültiges Format",
            
            "campaigns.details.tenant_selected": "Ausgewählter Mieter",
            
            "campaigns.details.tenants_selected": "Ausgewählte Mieter",
            
            "campaigns.details.sections.content.enter_message": "Nachricht eingeben",
            
            "date.formats.moment": "DD.MM.YYYY",
            
            "offers.controls.booking": "Erstelle eine Buchung",
            
            "offers.controls.offer": "Angebot senden",
            
            "offers.descriptions.booking": "Erstelle eine Buchung für Walk-ins. Fülle die Details aus und der Gesamtbetrag wird berechnet. Die Zahlung zwischen Vermieter und Mieter muss vor Ort abgewickelt werden, entweder in bar oder mit Karte. ",
            
            "offers.descriptions.offer": "Sende ein Angebot direkt an deinen Mieter. Fülle die Details aus und der Preis wird automatisch berechnet.  Der Mieter erhält das Angebot mit einem Link, über den er es online prüfen, annehmen und bezahlen kann.",
            
            "offers.title.booking": "Erstelle eine Buchung",
            
            "offers.title.offer": "Sende ein Angebot",
            
            "parsley.default_message": "Die Eingabe scheint nicht korrekt zu sein.",
            
            "parsley.type.email": "Die Eingabe muss eine gültige E-Mail-Adresse sein.",
            
            "parsley.type.url": "Die Eingabe muss eine gültige URL sein.",
            
            "parsley.type.number": "Die Eingabe muss eine gültige Zahl sein.",
            
            "parsley.type.integer": "Die Eingabe muss eine gültige Zahl sein.",
            
            "parsley.type.digits": "Die Eingabe darf nur Ziffern enthalten.",
            
            "parsley.type.alphanum": "Die Eingabe muss alphanumerisch sein.",
            
            "parsley.notblank": "Dieses Eingabefeld darf nicht leer sein.",
            
            "parsley.required": "Dies ist ein Pflichtfeld.",
            
            "parsley.pattern": "Die Eingabe scheint ungültig zu sein.",
            
            "parsley.min": "Die Eingabe muss grösser oder gleich %s sein.",
            
            "parsley.max": "Die Eingabe muss kleiner oder gleich %s sein.",
            
            "parsley.range": "Die Eingabe muss zwischen %s und %s liegen.",
            
            "parsley.minlength": "Die Eingabe ist zu kurz. Es müssen mindestens %s Zeichen eingegeben werden.",
            
            "parsley.maxlength": "Die Eingabe ist zu lang. Es dürfen höchstens %s Zeichen eingegeben werden.",
            
            "parsley.length": "Die Länge der Eingabe ist ungültig. Es müssen zwischen %s und %s Zeichen eingegeben werden.",
            
            "parsley.mincheck": "Sie müssen mindestens %s Auswahlmöglichkeiten auswählen.",
            
            "parsley.maxcheck": "Sie müssen %s Auswahlmöglichkeiten oder weniger auswählen.",
            
            "parsley.check": "Sie müssen zwischen den Optionen %s und %s wählen.",
            
            "parsley.equalto": "Dieses Feld muss dem anderen entsprechen.",
            
            "parsley.force_place_select": "Bitte wähle einen Ort aus der Dropdown-Liste aus.",
            
        },
    
        "de_formal": {
            
            "bundles.listings.title": "Inserate",
            
            "bundles.dates": "Termine",
            
            "bundles.available": "Verfügbar",
            
            "bundles.not_available": "Nicht verfügbar",
            
            "bundles.dates_not_available": "Diese Termine sind nicht verfügbar.",
            
            "bundles.listings.availability": "%{count} von %{total} Einträgen verfügbar",
            
            "timeline.editor_placeholder": "Geben Sie eine Nachricht ein...",
            
            "listings.listings_title": "Flächen",
            
            "invoice.title": "Rechnung",
            
            "scheduler.month": "Monat",
            
            "scheduler.quarter": "Quartal",
            
            "scheduler.today": "Heute",
            
            "scheduler.weeks": "Wochen",
            
            "scheduler.clear": "löschen",
            
            "stripe.persons.invalid_ssn_last_4": "Ungültiges Format",
            
            "campaigns.details.tenant_selected": "Ausgewählter Mieter",
            
            "campaigns.details.tenants_selected": "Ausgewählte Mieter",
            
            "campaigns.details.sections.content.enter_message": "Nachricht eingeben",
            
            "date.formats.moment": "DD.MM.YYYY",
            
            "offers.controls.booking": "Erstellen Sie eine Buchung",
            
            "offers.controls.offer": "Angebot senden",
            
            "offers.descriptions.booking": "Erstellen Sie eine Buchung für Walk-ins. Füllen Sie die Details aus und der Gesamtbetrag wird berechnet. Die Zahlung zwischen Vermieter und Mieter muss vor Ort abgewickelt werden.",
            
            "offers.descriptions.offer": "Senden Sie ein Angebot direkt an Ihren Mieter. Füllen Sie die Details aus und der Preis wird automatisch berechnet.  Der Mieter erhält das Angebot mit einem Link, über den er es online prüfen, annehmen und bezahlen kann.",
            
            "offers.title.booking": "Erstelle eine Buchung",
            
            "offers.title.offer": "Senden Sie ein Angebot",
            
            "parsley.default_message": "Die Eingabe scheint nicht korrekt zu sein.",
            
            "parsley.type.email": "Die Eingabe muss eine gültige E-Mail-Adresse sein.",
            
            "parsley.type.url": "Die Eingabe muss eine gültige URL sein.",
            
            "parsley.type.number": "Die Eingabe muss eine gültige Zahl sein.",
            
            "parsley.type.integer": "Die Eingabe muss eine gültige Zahl sein.",
            
            "parsley.type.digits": "Die Eingabe darf nur Ziffern enthalten.",
            
            "parsley.type.alphanum": "Die Eingabe muss alphanumerisch sein.",
            
            "parsley.notblank": "Dieses Eingabefeld darf nicht leer sein.",
            
            "parsley.required": "Dies ist ein Pflichtfeld.",
            
            "parsley.pattern": "Die Eingabe scheint ungültig zu sein.",
            
            "parsley.min": "Die Eingabe muss grösser oder gleich %s sein.",
            
            "parsley.max": "Die Eingabe muss kleiner oder gleich %s sein.",
            
            "parsley.range": "Die Eingabe muss zwischen %s und %s liegen.",
            
            "parsley.minlength": "Die Eingabe ist zu kurz. Es müssen mindestens %s Zeichen eingegeben werden.",
            
            "parsley.maxlength": "Die Eingabe ist zu lang. Es dürfen höchstens %s Zeichen eingegeben werden.",
            
            "parsley.length": "Die Länge der Eingabe ist ungültig. Es müssen zwischen %s und %s Zeichen eingegeben werden.",
            
            "parsley.mincheck": "Sie müssen mindestens %s Auswahlmöglichkeiten auswählen.",
            
            "parsley.maxcheck": "Sie müssen %s Auswahlmöglichkeiten oder weniger auswählen.",
            
            "parsley.check": "Sie müssen zwischen den Optionen %s und %s wählen.",
            
            "parsley.equalto": "Dieses Feld muss dem anderen entsprechen.",
            
            "parsley.force_place_select": "Bitte wählen Sie eine Fläche aus dem Dropdown-Menü.",
            
        },
    
        "fr": {
            
            "bundles.listings.title": "Annonces",
            
            "bundles.dates": "Dates",
            
            "bundles.available": "Disponible",
            
            "bundles.not_available": "Non disponible",
            
            "bundles.dates_not_available": "Ces dates ne sont pas disponibles.",
            
            "bundles.listings.availability": "%{count} annonces disponibles sur %{total}",
            
            "timeline.editor_placeholder": "Saisissez votre message...",
            
            "listings.listings_title": "Annonces",
            
            "invoice.title": "Facture",
            
            "scheduler.month": "Mois",
            
            "scheduler.quarter": "Trimestre",
            
            "scheduler.today": "Aujourd'hui",
            
            "scheduler.weeks": "Semaines",
            
            "scheduler.clear": "Clear",
            
            "stripe.persons.invalid_ssn_last_4": "Format non valide",
            
            "campaigns.details.tenant_selected": "Tenant selected",
            
            "campaigns.details.tenants_selected": "Tenants selected",
            
            "campaigns.details.sections.content.enter_message": "Enter your message",
            
            "date.formats.moment": "DD.MM.YYYY",
            
            "offers.controls.booking": "Créer une réservation",
            
            "offers.controls.offer": "Envoyer l'offre",
            
            "offers.descriptions.booking": "Créez une réservation de dernière minute. Remplissez les détails et le total sera calculé. Le paiement entre le propriétaire et le locataire doit être effectué en personne, soit en espèces, soit par carte.",
            
            "offers.descriptions.offer": "Envoyez une offre directement à votre locataire. Remplissez les détails et le prix sera calculé automatiquement. Le locataire recevra l'offre avec un lien de demande de paiement.",
            
            "offers.title.booking": "Créer une réservation",
            
            "offers.title.offer": "Envoyer une offre",
            
            "parsley.default_message": "Cette valeur ne semble pas valide.",
            
            "parsley.type.email": "Cette valeur n'est pas une adresse email valide.",
            
            "parsley.type.url": "Cette valeur n'est pas une URL valide.",
            
            "parsley.type.number": "Cette valeur doit être un nombre valide.",
            
            "parsley.type.integer": "Cette valeur doit être un entier.",
            
            "parsley.type.digits": "Cette valeur doit être numérique.",
            
            "parsley.type.alphanum": "Cette valeur doit être alphanumérique.",
            
            "parsley.notblank": "Cette valeur ne peut pas être vide.",
            
            "parsley.required": "Ce champ est obligatoire.",
            
            "parsley.pattern": "Cette valeur semble ne pas être valide.",
            
            "parsley.min": "Cette valeur ne doit pas être inférieure à %s.",
            
            "parsley.max": "Cette valeur ne doit pas être supérieure à %s.",
            
            "parsley.range": "Cette valeur doit être comprise entre %s et %s.",
            
            "parsley.minlength": "Cette valeur est trop courte. Elle doit avoir au minimum %s caractères.",
            
            "parsley.maxlength": "Cette chaîne est trop longue. Elle doit avoir au maximum %s caractères.",
            
            "parsley.length": "Cette valeur doit contenir entre %s et %s caractères.",
            
            "parsley.mincheck": "Vous devez sélectionner au moins %s choix.",
            
            "parsley.maxcheck": "Vous devez sélectionner %s choix maximum.",
            
            "parsley.check": "Vous devez sélectionner entre %s et %s choix.",
            
            "parsley.equalto": "Cette valeur doit être identique.",
            
            "parsley.force_place_select": "Veuillez sélectionner un lieu dans le menu déroulant.",
            
        },
    
        "it": {
            
            "bundles.listings.title": "Inserzioni",
            
            "bundles.dates": "Date",
            
            "bundles.available": "Disponibile",
            
            "bundles.not_available": "Non disponibile",
            
            "bundles.dates_not_available": "Queste date non sono disponibili.",
            
            "bundles.listings.availability": "Sono disponibili %{count} annunci su %{total}",
            
            "timeline.editor_placeholder": "Scrivi un messaggio...",
            
            "listings.listings_title": "Inserzioni",
            
            "invoice.title": "Fattura",
            
            "scheduler.month": "Mese",
            
            "scheduler.quarter": "Trimestre",
            
            "scheduler.today": "Oggi",
            
            "scheduler.weeks": "Settimane",
            
            "scheduler.clear": "Cancella",
            
            "stripe.persons.invalid_ssn_last_4": "Formato non valido",
            
            "campaigns.details.tenant_selected": "Affittuario selezionato",
            
            "campaigns.details.tenants_selected": "Affittuari selezionati",
            
            "campaigns.details.sections.content.enter_message": "Scrivi un messaggio",
            
            "date.formats.moment": "DD/MM/YYYY",
            
            "offers.controls.booking": "Crea una prenotazione",
            
            "offers.controls.offer": "Inviare l'offerta",
            
            "offers.descriptions.booking": "Crea una prenotazione walk-in. Compila i dettagli per ottenere il calcolo del totale. Il pagamento tra locatore e affittuario deve essere effettuato di persona, in contanti o con carta.",
            
            "offers.descriptions.offer": "Invia un'offerta direttamente al tuo affittuario. Compila i dettagli e il prezzo verrà calcolato automaticamente. L'affittuario riceverà l'offerta con un link contenente la richiesta di pagamento.",
            
            "offers.title.booking": "Prenotazione confermata",
            
            "offers.title.offer": "Invia un'offerta",
            
            "parsley.default_message": "Questo valore sembra non essere valido.",
            
            "parsley.type.email": "Questo valore deve essere un indirizzo e-mail valido.",
            
            "parsley.type.url": "Questo valore deve essere un URL valido.",
            
            "parsley.type.number": "Questo valore deve essere un numero valido.",
            
            "parsley.type.integer": "Questo valore deve essere un numero intero valido.",
            
            "parsley.type.digits": "Questo valore deve essere costituito da cifre.",
            
            "parsley.type.alphanum": "Questo valore deve essere alfanumerico.",
            
            "parsley.notblank": "Questo valore non può essere lasciato vuoto.",
            
            "parsley.required": "Questo valore è obbligatorio.",
            
            "parsley.pattern": "Questo valore sembra non essere valido.",
            
            "parsley.min": "Questo valore deve essere maggiore o uguale a %s.",
            
            "parsley.max": "Questo valore deve essere inferiore o uguale a %s.",
            
            "parsley.range": "Questo valore deve essere compreso tra %s e %s.",
            
            "parsley.minlength": "Questo valore è troppo corto. Deve comprendere almeno %s caratteri.",
            
            "parsley.maxlength": "Questo valore è troppo lungo. Deve comprendere non più di %s caratteri.",
            
            "parsley.length": "La lunghezza del valore non è valida. Deve essere compresa tra %s e %s caratteri.",
            
            "parsley.mincheck": "È necessario selezionare almeno %s opzioni.",
            
            "parsley.maxcheck": "È possibile selezionare non più di %s opzioni.",
            
            "parsley.check": "È necessario selezionare tra %s e %s opzioni.",
            
            "parsley.equalto": "Questo valore deve essere identico all'altro.",
            
            "parsley.force_place_select": "Seleziona un luogo dal menu a tendina.",
            
        },
    
        "hu": {
            
            "bundles.listings.title": "Hirdetések",
            
            "bundles.dates": "Dátumok",
            
            "bundles.available": "Elérhető",
            
            "bundles.not_available": "Nem elérhető",
            
            "bundles.dates_not_available": "Ezek az időpontok nem elérhetők.",
            
            "bundles.listings.availability": "%{count} darab elérhető hirdetés a %{total} közül",
            
            "timeline.editor_placeholder": "Írja be üzenetét...",
            
            "listings.listings_title": "Promóciós területek és reklámfelületek",
            
            "invoice.title": "Számla",
            
            "scheduler.month": "Hónap",
            
            "scheduler.quarter": "Negyedév",
            
            "scheduler.today": "Ma",
            
            "scheduler.weeks": "Hetek",
            
            "scheduler.clear": "Törlés",
            
            "stripe.persons.invalid_ssn_last_4": "Érvénytelen formátum",
            
            "campaigns.details.tenant_selected": "Bérlő kiválasztva",
            
            "campaigns.details.tenants_selected": "Bérlők kiválasztva",
            
            "campaigns.details.sections.content.enter_message": "Írja le az üzenetét",
            
            "date.formats.moment": "YYYY.MM.DD.",
            
            "offers.controls.booking": "Foglalás létrehozása",
            
            "offers.controls.offer": "Ajánlat küldése",
            
            "offers.descriptions.booking": "Hozzon létre foglalást azonnali bérlést igénylő ügyfelek számára. Töltse ki a részleteket, és az összeg automatikusan kiszámításra kerül. A bérbeadó és a bérlő közötti fizetést személyesen kell lebonyolítani, készpénzben vagy kártyával.",
            
            "offers.descriptions.offer": "Küldjön közvetlen ajánlatot a bérlőjének. Töltse ki az információkat, és az ár automatikusan kiszámításra kerül. A bérlő megkapja az ajánlatot egy linkkel, ahol megtekintheti, elfogadhatja és online ki is fizetheti.",
            
            "offers.title.booking": "Foglalás létrehozása",
            
            "offers.title.offer": "Ajánlat küldése",
            
            "parsley.default_message": "Ez az érték érvénytelennek tűnik.",
            
            "parsley.type.email": "Ennek a mezőnek érvényes e-mail címet kell tartalmaznia.",
            
            "parsley.type.url": "Ennek a mezőnek érvényes URL-t kell tartalmaznia.",
            
            "parsley.type.number": "Ennek a mezőnek érvényes számot kell tartalmaznia.",
            
            "parsley.type.integer": "Ennek a mezőnek érvényes egész számot kell tartalmaznia.",
            
            "parsley.type.digits": "Ennek a mezőnek számjegyeket kell tartalmaznia.",
            
            "parsley.type.alphanum": "Ennek a mezőnek alfanumerikusnak kell lennie.",
            
            "parsley.notblank": "Ez a mező nem lehet üres.",
            
            "parsley.required": "Ez a mező kötelező.",
            
            "parsley.pattern": "Ez a mező érvénytelennek tűnik.",
            
            "parsley.min": "Ennek az értéknek nagyobbnak vagy egyenlőnek kell lennie, mint %s.",
            
            "parsley.max": "Ennek az értéknek kisebbnek vagy egyenlőnek kell lennie, mint %s.",
            
            "parsley.range": "Ennek az értéknek %s és %s között kell lennie.",
            
            "parsley.minlength": "Ez az érték túl rövid. Legalább %s karakter hosszúnak kell lennie.",
            
            "parsley.maxlength": "Ez az érték túl hosszú. Legfeljebb %s karakter hosszú lehet.",
            
            "parsley.length": "Az érték hossza érvénytelen. %s és %s karakter közötti hosszúságúnak kell lennie.",
            
            "parsley.mincheck": "Legalább %s lehetőséget kell kiválasztania.",
            
            "parsley.maxcheck": "Legfeljebb %s lehetőséget választhat ki.",
            
            "parsley.check": "Ki kell választania %s és %s közötti lehetőséget.",
            
            "parsley.equalto": "Ennek az értéknek azonosnak kell lennie.",
            
            "parsley.force_place_select": "Kérjük, válasszon egy helyet a legördülő listából.",
            
        },
    
        "sv": {
            
            "bundles.listings.title": "Listings",
            
            "bundles.dates": "Dates",
            
            "bundles.available": "Available",
            
            "bundles.not_available": "Not available",
            
            "bundles.dates_not_available": "These dates are not available.",
            
            "bundles.listings.availability": "%{count} of %{total} listings available",
            
            "timeline.editor_placeholder": "Enter your message...",
            
            "listings.listings_title": "Spaces",
            
            "invoice.title": "Invoice",
            
            "scheduler.month": "Month",
            
            "scheduler.quarter": "Quarter",
            
            "scheduler.today": "Today",
            
            "scheduler.weeks": "Weeks",
            
            "scheduler.clear": "Clear",
            
            "stripe.persons.invalid_ssn_last_4": "Invalid format",
            
            "campaigns.details.tenant_selected": "Tenant selected",
            
            "campaigns.details.tenants_selected": "Tenants selected",
            
            "campaigns.details.sections.content.enter_message": "Enter your message",
            
            "date.formats.moment": "MM/DD/YYYY",
            
            "offers.controls.booking": "Create a booking",
            
            "offers.controls.offer": "Send offer",
            
            "offers.descriptions.booking": "Create a booking for walk-ins. Fill in the details and the total will be calculated. The payment between the landlord and tenant must be handled in person, either by cash or card. ",
            
            "offers.descriptions.offer": "Send an offer directly to your tenant. Fill in the details and the price will be calculated automatically. The tenant will receive the offer with a link to review, accept and pay it online.",
            
            "offers.title.booking": "Create a booking",
            
            "offers.title.offer": "Send an offer",
            
            "parsley.default_message": "This value seems to be invalid.",
            
            "parsley.type.email": "This value should be a valid email.",
            
            "parsley.type.url": "This value should be a valid url.",
            
            "parsley.type.number": "This value should be a valid number.",
            
            "parsley.type.integer": "This value should be a valid integer.",
            
            "parsley.type.digits": "This value should be digits.",
            
            "parsley.type.alphanum": "This value should be alphanumeric.",
            
            "parsley.notblank": "This value should not be blank.",
            
            "parsley.required": "This value is required.",
            
            "parsley.pattern": "This value seems to be invalid.",
            
            "parsley.min": "This value should be greater than or equal to %s.",
            
            "parsley.max": "This value should be lower than or equal to %s.",
            
            "parsley.range": "This value should be between %s and %s.",
            
            "parsley.minlength": "This value is too short. It should have %s characters or more.",
            
            "parsley.maxlength": "This value is too long. It should have %s characters or less.",
            
            "parsley.length": "This value length is invalid. It should be between %s and %s characters long.",
            
            "parsley.mincheck": "You must select at least %s choices.",
            
            "parsley.maxcheck": "You must select %s choices or less.",
            
            "parsley.check": "You must select between %s and %s choices.",
            
            "parsley.equalto": "This value should be the same.",
            
            "parsley.force_place_select": "Please select a place from the dropdown.",
            
        },
    
    };
};
